// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"aAksx","onDark":"Fayaf"};